var _path, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBronzeRank6(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 201 199",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bronze_rank_6_svg__clip0_1947_6703)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "bronze_rank_6_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 201,
    height: 199
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200.865 0H0v198.192h200.865V0z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bronze_rank_6_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.335 38.296c-5.345-5.607-14.621-4.15-18.038 2.798-8.93 18.138-6.153 40.672 8.615 56.17 18.43 19.338 48.732 20.585 68.68 3.208L37.334 38.296z",
    fill: "#DDA37D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.322 75.638C6.903 73.396-.439 79.238.024 86.963c1.201 20.181 14.761 38.401 35.265 44.594 25.585 7.725 52.553-6.134 61.308-31.085L14.322 75.638z",
    fill: "#D8966B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.338 121.8c-7.507 1.925-10.76 10.722-6.358 17.09 11.497 16.64 32.546 25.209 53.291 19.895 25.89-6.632 41.771-32.443 36.315-58.313l-42.55 10.898-40.704 10.424.006.006z",
    fill: "#D38959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.531 38.296c5.344-5.607 14.621-4.15 18.037 2.798 8.931 18.138 6.153 40.672-8.614 56.17-18.43 19.338-48.732 20.585-68.68 3.208l59.257-62.176z",
    fill: "#DDA37D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.543 75.638c7.419-2.242 14.762 3.6 14.305 11.33-1.202 20.182-14.762 38.402-35.266 44.594-25.585 7.726-52.553-6.133-61.308-31.085l82.269-24.84z",
    fill: "#D8966B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.522 121.8c7.507 1.925 10.759 10.722 6.358 17.09-11.497 16.64-32.547 25.209-53.291 19.895-25.89-6.632-41.77-32.443-36.315-58.313l42.55 10.898 40.704 10.424-.006.006z",
    fill: "#D38959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.792 0h108.224c6.47 0 11.72 5.244 11.72 11.706v120.728c0 36.289-29.499 65.752-65.832 65.752-36.332 0-65.832-29.463-65.832-65.752V11.706C35.072 5.244 40.322 0 46.792 0z",
    fill: "#CE7C46"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M63.195 67.49h75.413c4.506 0 8.169 3.653 8.169 8.16v49.345c0 25.291-20.557 45.817-45.873 45.817-25.321 0-45.872-20.532-45.872-45.817V75.649c0-4.5 3.657-8.159 8.169-8.159h-.006z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.608 69.831c3.211 0 5.825 2.61 5.825 5.818v49.346c0 23.974-19.526 43.476-43.529 43.476-24.002 0-43.528-19.502-43.528-43.476V75.649c0-3.207 2.613-5.818 5.825-5.818h75.413m0-2.34h-75.42c-4.511 0-8.168 3.651-8.168 8.158v49.346c0 25.303 20.54 45.817 45.872 45.817 25.334 0 45.873-20.514 45.873-45.817V75.649c0-4.507-3.657-8.159-8.169-8.159h.012z",
    fill: "#fff",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.016 0h-44.982L35.072 74.87v51.583l125.3-125.154A11.673 11.673 0 00155.016 0zM95.712 112.201l71.024-70.938v-29.23L81.079 97.587l14.633 14.615z",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M64.25 27.31l1.687 5.18c.188.573.721.96 1.325.96h5.456c1.347 0 1.91 1.726.82 2.517l-4.413 3.201a1.39 1.39 0 00-.504 1.557l1.688 5.18c.416 1.282-1.049 2.347-2.145 1.557l-4.412-3.202a1.4 1.4 0 00-1.635 0l-4.413 3.202c-1.09.79-2.561-.275-2.145-1.557l1.688-5.18a1.394 1.394 0 00-.504-1.557l-4.413-3.201c-1.09-.79-.533-2.517.82-2.517h5.456c.604 0 1.137-.387 1.325-.96l1.688-5.18c.416-1.282 2.232-1.282 2.648 0h-.017z",
    stroke: "#000",
    strokeWidth: 8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.25 27.31l1.687 5.18c.188.573.721.96 1.325.96h5.456c1.347 0 1.91 1.726.82 2.517l-4.413 3.201a1.39 1.39 0 00-.504 1.557l1.688 5.18c.416 1.282-1.049 2.347-2.145 1.557l-4.412-3.202a1.4 1.4 0 00-1.635 0l-4.413 3.202c-1.09.79-2.561-.275-2.145-1.557l1.688-5.18a1.394 1.394 0 00-.504-1.557l-4.413-3.201c-1.09-.79-.533-2.517.82-2.517h5.456c.604 0 1.137-.387 1.325-.96l1.688-5.18c.416-1.282 2.232-1.282 2.648 0h-.017z",
    fill: "#FEE066"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M139.675 27.31l1.687 5.18c.188.573.721.96 1.325.96h5.455c1.348 0 1.911 1.726.821 2.517l-4.413 3.201a1.392 1.392 0 00-.504 1.557l1.688 5.18c.416 1.282-1.049 2.347-2.145 1.557l-4.413-3.202a1.4 1.4 0 00-1.635 0l-4.412 3.202c-1.09.79-2.561-.275-2.145-1.557l1.688-5.18a1.395 1.395 0 00-.504-1.557l-4.413-3.201c-1.09-.79-.533-2.517.821-2.517h5.455c.604 0 1.137-.387 1.325-.96l1.687-5.18c.416-1.282 2.233-1.282 2.649 0h-.017z",
    stroke: "#000",
    strokeWidth: 8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.675 27.31l1.687 5.18c.188.573.721.96 1.325.96h5.455c1.348 0 1.911 1.726.821 2.517l-4.413 3.201a1.392 1.392 0 00-.504 1.557l1.688 5.18c.416 1.282-1.049 2.347-2.145 1.557l-4.413-3.202a1.4 1.4 0 00-1.635 0l-4.412 3.202c-1.09.79-2.561-.275-2.145-1.557l1.688-5.18a1.395 1.395 0 00-.504-1.557l-4.413-3.201c-1.09-.79-.533-2.517.821-2.517h5.455c.604 0 1.137-.387 1.325-.96l1.687-5.18c.416-1.282 2.233-1.282 2.649 0h-.017z",
    fill: "#FEE066"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M102.029 19.227l2.034 6.25c.223.691.867 1.16 1.6 1.16h6.581c1.629 0 2.303 2.077.984 3.031l-5.321 3.863a1.68 1.68 0 00-.609 1.873l2.033 6.251c.504 1.545-1.266 2.833-2.584 1.873l-5.321-3.863a1.682 1.682 0 00-1.975 0l-5.32 3.863c-1.32.954-3.09-.328-2.585-1.873l2.033-6.25a1.68 1.68 0 00-.61-1.874l-5.32-3.863c-1.319-.954-.639-3.031.984-3.031h6.581c.727 0 1.371-.469 1.6-1.16l2.034-6.25c.503-1.545 2.689-1.545 3.193 0h-.012z",
    stroke: "#000",
    strokeWidth: 8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.029 19.227l2.034 6.25c.223.691.867 1.16 1.6 1.16h6.581c1.629 0 2.303 2.077.984 3.031l-5.321 3.863a1.68 1.68 0 00-.609 1.873l2.033 6.251c.504 1.545-1.266 2.833-2.584 1.873l-5.321-3.863a1.682 1.682 0 00-1.975 0l-5.32 3.863c-1.32.954-3.09-.328-2.585-1.873l2.033-6.25a1.68 1.68 0 00-.61-1.874l-5.32-3.863c-1.319-.954-.639-3.031.984-3.031h6.581c.727 0 1.371-.469 1.6-1.16l2.034-6.25c.503-1.545 2.689-1.545 3.193 0h-.012z",
    fill: "#FEE066"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bronze_rank_6_svg__clip0_1947_6703"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h201v199H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBronzeRank6);
export default ForwardRef;